// removed by extract-text-webpack-plugin
module.exports = {"wrapper-opacity":"magazines_1IfTT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Opacity/styles.scss
// module id = 1211
// module chunks = 1